export default "https://cdn-static.gokick.com/assets/cf07e8c5970f78b6a967654f4a6b4453caa2db11/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";